import { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CometChat } from '@cometchat-pro/chat';
import classNames from 'classnames';
import Button from 'antd/lib/button/button';
import Divider from 'antd/lib/divider';
import Form from 'antd/lib/form/Form';
import Item from 'antd/lib/form/FormItem';
import Input from 'antd/lib/input/Input';

import { isLoggedInSelector } from 'store/selectors/messagesSelectors';
import { userSelectionAction } from 'store/actions/userActions';
import history from 'utils/history';
import { formRules, STORAGE_KEYS } from 'utils/constants/constants';
import { EMAIL } from 'utils/constants/wordsConstants';

const ShowAsUser: FC = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(isLoggedInSelector);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const userSelection = localStorage.getItem(STORAGE_KEYS.userSelection);

  const handleClearSelection = async() => {
    localStorage.removeItem(STORAGE_KEYS.userSelection);
    isLoggedIn && CometChat.logout();
    history.push({ search: '' });
    document.location.reload();
  };

  const handleSubmit = async(email: { [EMAIL]: string }) => {
    setIsLoading(true);
    await dispatch(userSelectionAction(email));
    setIsLoading(false);
  };

  return (
    <div className="w-96">
      <h2 className="my-4">{userSelection ? `Showing as ${JSON.parse(userSelection).email}` : 'Show as user'}</h2>
      <Form layout="vertical" validateTrigger="onSubmit" onFinish={handleSubmit}>
        <Item name={EMAIL} label="User Email" rules={[formRules.required, formRules.email]}>
          <Input size="large" placeholder="Enter user email" />
        </Item>
        <Divider />
        <div className="flex items-center justify-between">
          <Button
            size="small"
            type="link"
            className={classNames('text-black-70 dark:text-black-30', { invisible: !userSelection })}
            onClick={handleClearSelection}
          >
            Clear user selection
          </Button>
          <Button
            size="large"
            type="primary"
            htmlType="submit" loading={isLoading}
          >
            Change to user</Button>
        </div>
      </Form>
    </div>
  );
};

export default ShowAsUser;
